import type { Node as ProsemirrorNode } from "prosemirror-model";

import { IntegrationObjectTokenNode } from "@agent-ui/features/chat/components/chat-elements/message-input/IntegrationObjectTokenNode";
import { serializeChatTokenPayload } from "@agent-ui/features/chat/utils/chatTokenSerialization";
import { mergeAttributes, Node } from "@tiptap/core";

interface MarkdownSerializerState {
  text: (text: string, escape?: boolean) => void;
}

export default Node.create({
  name: "integrationObjectComponent",

  group: "inline",

  inline: true,

  selectable: false,
  atom: true,

  parseHTML() {
    return [
      {
        tag: "integration-object-component",
      },
    ];
  },

  addAttributes() {
    return {
      data: {
        default: null,
        parseHTML: (element) => {
          const dataAttr = element.getAttribute("data");
          if (!dataAttr) {
            return null;
          }
          try {
            return JSON.parse(dataAttr);
          } catch {
            return null;
          }
        },
        renderHTML: (attributes) => {
          if (!attributes.data) {
            return {};
          }
          return {
            data: JSON.stringify(attributes.data),
          };
        },
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return ["integration-object-component", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return IntegrationObjectTokenNode;
  },

  addStorage() {
    return {
      markdown: {
        serialize: (state: MarkdownSerializerState, node: ProsemirrorNode) => {
          const token = serializeChatTokenPayload(
            "integration-object",
            node.attrs.data,
          );
          if (token) {
            state.text(token, false);
          }
        },
      },
    };
  },
});
